import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import Notification from '/Foundation/Common/code/Views/Foundation/Common/Notifications/Notification';

const Activate = ({ Text, Success }) => {
  return (
    <>
      {Text && (
        <div className="mt-8 prosite-activate-text">
          <Notification Type={Success ? 'success' : 'error'} Size={'sm'} Message={Text} ShowIcon={true} />
        </div>
      )}
    </>
  );
};

const rootElement = document.getElementById('REACT_proUserActivation');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <Activate {...window._THULEDATA.ProUser} />
    </Sentry.ErrorBoundary>
  );
}
